import Plyr from "plyr";
// import "plyr/dist/plyr.css";

class VideoPlayer {
  constructor(container) {
    this.container = container;
    this.videoId = container.dataset.videoId;
    this.coverImage = container.dataset.coverImage;
    this.autoplay = container.dataset.autoplay === "true";
    this.loop = container.dataset.loop === "true";
    this.controls = container.dataset.controls === "true";

    this.init();
  }

  init() {
    // Create custom controls
    const controls = ["play-large", "play", "progress", "current-time", "duration", "mute", "volume", "fullscreen"];

    // Setup the player
    const player = new Plyr(this.container.querySelector("[data-plyr-embed-id]"), {
      controls,
      hideControls: true,
      resetOnEnd: true,
      keyboard: { focused: true, global: true },
      tooltips: { controls: true, seek: true },
      muted: true,
      youtube: {
        noCookie: true,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        mute: 1
      },
      // Use our custom play button until video starts
      clickToPlay: false
    });

    // Handle custom cover image and play button
    if (this.coverImage && !this.autoplay) {
      const coverContainer = this.container.querySelector(".video-cover");
      const playButton = this.container.querySelector(".video-play-button");

      if (coverContainer && playButton) {
        playButton.addEventListener("click", () => {
          coverContainer.style.opacity = "0";
          setTimeout(() => {
            coverContainer.style.display = "none";
          }, 500); // Match this with your CSS transition duration
          player.play();
        });

        // Show cover and play button initially
        coverContainer.style.display = "flex";
        coverContainer.style.opacity = "1";
      }
    }

    // Handle autoplay if enabled
    if (this.autoplay) {
      player.muted = true;
      player.play();
    }

    // Handle loop if enabled
    if (this.loop) {
      player.on("ended", () => {
        player.restart();
      });
    }

    // Store player instance
    this.player = player;
  }
}

// Initialize all video players on the page
document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll("[data-video-container]");
  containers.forEach((container) => new VideoPlayer(container));
});

export default VideoPlayer;
